"use client";
import {
  useFormContext
} from "../__chunks/DPO6VSJT.js";
import {
  useButton
} from "../__chunks/5O7V7O3A.js";
import "../__chunks/XVQ3TNPZ.js";
import "../__chunks/KSMDNUGB.js";
import "../__chunks/HJIEYVEO.js";
import "../__chunks/SHA3WOPI.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/LFJDOMBA.js";
import "../__chunks/6WEF4WY5.js";
import "../__chunks/OZVWZODE.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/2SMRF6AD.js";

// src/form/form-submit.ts
import { invariant } from "@ariakit/core/utils/misc";
var useFormSubmit = createHook(
  (_a) => {
    var _b = _a, { store, accessibleWhenDisabled = true } = _b, props = __objRest(_b, ["store", "accessibleWhenDisabled"]);
    const context = useFormContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "FormSubmit must be wrapped in a Form component."
    );
    props = __spreadValues({
      type: "submit",
      disabled: store.useState("submitting")
    }, props);
    props = useButton(__spreadProps(__spreadValues({}, props), { accessibleWhenDisabled }));
    return props;
  }
);
var FormSubmit = createComponent((props) => {
  const htmlProps = useFormSubmit(props);
  return createElement("button", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  FormSubmit.displayName = "FormSubmit";
}
export {
  FormSubmit,
  useFormSubmit
};
